module.exports = __webpack_public_path__ + "img/videodraft-2.8653b8fb.jpg";